import { Heading } from "@chakra-ui/layout";

export const ProductMastheadTitle = ({ children }) => {
  return (
    <Heading fontSize={{base: "4xl", lg: "5xl"}} mb={{base: 2, lg: 1}} fontWeight={700}>
      {children}
    </Heading>
  );
};
